import { render, staticRenderFns } from "./brandMultipleSelect.vue?vue&type=template&id=cd0a2068"
import script from "./brandMultipleSelect.vue?vue&type=script&lang=js"
export * from "./brandMultipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports